/**
 * Ordena materias para selects: primero las que tienen pendientes (mayor cantidad
 * primero), luego las demás alfabéticamente.
 */
export function sortSubjectsByPending(subjects, getPendingCount) {
  if (!Array.isArray(subjects) || subjects.length === 0) return [];
  const tier = (n) => (n > 0 ? 1 : 0);
  return [...subjects].sort((a, b) => {
    const ca = Number(getPendingCount(a)) || 0;
    const cb = Number(getPendingCount(b)) || 0;
    const ta = tier(ca);
    const tb = tier(cb);
    if (tb !== ta) return tb - ta;
    if (cb !== ca) return cb - ca;
    return String(a.name || '').localeCompare(String(b.name || ''), undefined, {
      sensitivity: 'base',
    });
  });
}
